export type ClockConfigTypes = {
  primaryTimezone: string
  secondaryTimezones: string[]
}
